import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-collection"
export default class extends Controller {
  static targets = ['checkAll']
  updateRequired(event) {
    if (!event.target.checked && this.hasCheckAllTarget) {
      this.checkAllTarget.checked = false
    }

    const collection = event.target.dataset.collection
    const collections = document.querySelectorAll('[data-collection="' + collection + '"]');

    const d = Array.from(collections).map(function(c) {
      return c.value && c.checked;
    });

    const optional = d.some(function(e) { return e });

    collections.forEach(function(element) {
      if (optional) {
        element.removeAttribute('required');
      } else {
        element.setAttribute('required', 'required');
      }
    });
  }

  selectAll(event) {
    const checked = event.target.checked
    const collection = event.target.dataset.collection

    document.querySelectorAll('[data-collection="' + collection + '"]').forEach(function(element) {
      element.checked = checked;
    });
  }
}
